import {
  DefaultMenu
} from '../objects/FeaturesSetting.js';
import useRouteAuthorization from './routeAuthorization';
import { routes as customRoutes } from '../modules';

const routes = useRouteAuthorization(DefaultMenu.routes, { name: 'Forbidden' });

export default [
  ...customRoutes,
  {
    path: '/Login',
    name: 'Login',
    component: () => import(/* webpackPrefetch: true */'@/pages/Login'),
    props: (route) => {
      const { redirect } = route.query;
      return ({ redirect });
    },
  },
  {
    path: '/Forgot',
    name: 'Forgot',
    component: () => import('@/pages/ForgotPassword')
  },
  {
    path: '/Reset',
    name: 'Reset',
    component: () => import('@/pages/ResetPassword'),
    props: (route) => {
      const { code } = route.query;

      return ({ code });
    }
  },
  {
    path: '/Logout',
    name: 'Logout',
    component: () => import('@/pages/Logout'),
    props: (route) => {
      const { redirect } = route.query;
      return ({ redirect });
    },
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('@/pages/Register'),
    props: (route) => {
      const { redirect } = route.query;
      const { code } = route.params;

      return ({ redirect, code });
    }
  },
  {
    path: '/Invitation',
    name: 'Invitation',
    component: () => import('@/pages/Invitation'),
  },
  {
    path: '/',
    component: () => import(/* webpackPrefetch: true */'@/pages/Features'),
    meta: { verifyAuth: true },
    props: (route) => {
      const { t } = route.query;

      return ({ t });
    },
    children: [
      ...routes,
      {
        name: 'FeatureIndex',
        path: '/',
        meta: { verifyAuth: true },
        component: () => import(/* webpackPrefetch: true */'@/pages/Features/Index.vue')
      },
      {
        name: 'FeatureNotFound',
        path: '/NotFound',
        meta: { verifyAuth: true },
        component: () => import('@/pages/NotFound.vue')
      },
      {
        name: 'Forbidden',
        path: '/Forbidden',
        meta: { verifyAuth: true },
        component: () => import('@/pages/Forbidden.vue')
      },
      {
        name: 'Features',
        path: '*',
        redirect: '/NotFound'
      }
    ]
  }
];
